<template>
    <div class="e_handle_content page_update_supply">
        <div class="topOperation">
            <div class="top-left">
                <ShowNavHead />
            </div>
        </div>
        <div class="main-con">
            <div class="crumbs">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item>产品</el-breadcrumb-item>
                    <el-breadcrumb-item>灵活用工</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/supplierManage?active=first' }">施工队列表</el-breadcrumb-item>
                    <el-breadcrumb-item>{{pageTitle}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="e_handle_box">
                <div class="f_form_btn">
                    <p class="r_edit_title01">基础信息</p>
                    <div class="r_title_btns">
                        <el-button v-if="isEdit" type="primary" size="small" @click="addOneHandle">新增施工队员</el-button>
                    </div>
                </div>
                <div class="e_handle_form" v-loading="formLoading">
                    <el-form :inline="true" :rules="basicRules" ref="enterResumeForm" :model="basicQuery" class="e_form_box" label-width="165px">
                        <el-form-item label="施工队编号:" prop="StrConstrteamCode">
                            <el-input :disabled="isEdit" @blur="checkPresentHandle" v-model="basicQuery.StrConstrteamCode" size="small" clearable placeholder="规则按地区缩写+顺序数字,如:北京001=BJ001"></el-input>
                        </el-form-item>
                        <el-form-item label="施工队名称:" prop="StrConstrteamName" v-if="!isNull(basicQuery.StrConstrteamCode)">
                            <div class="c_form_box">
                                <span class="c_edit_txt">{{basicQuery.StrConstrteamCode}}</span>
                                <el-input class="c_edit_input" v-model="basicQuery.StrRegisShortCompany" size="small" clearable placeholder="请填写公司简称"></el-input>
                            </div>
                        </el-form-item>
                        <el-form-item label="区域:" prop="StrArea">
                            <el-select v-model="basicQuery.StrArea" placeholder="" filterable size="small" @change="areaChangeHandle">
                                <el-option v-for="(item,i) in areaList" :key="i+'b'" :label="item.StrCont" :value="item.StrCont"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="城市公司:" prop="StrCityCompany">
                            <el-select v-model="basicQuery.StrCityCompany" placeholder="" filterable size="small" @change="cityCompanyHandle">
                                <el-option v-for="(item,i) in cityCompanyList" :key="i+'d'" :label="item.StrCont" :value="item.StrCont"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="城市:" prop="StrCity">
                            <el-select v-model="basicQuery.StrCity" placeholder="" filterable size="small">
                                <el-option v-for="(item,i) in cityList" :key="i+'p'" :label="item.strname" :value="item.strname"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="公司名称:" prop="StrRegisCompany">
                            <el-input v-model="basicQuery.StrRegisCompany" size="small" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="公司统一社会信用代码:" prop="StrUsccode">
                            <el-input v-model="basicQuery.StrUsccode" size="small" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="负责人姓名:" prop="StrresponName">
                            <el-input v-model="basicQuery.StrresponName" size="small" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="负责人身份证号:" prop="StrresponIdcard">
                            <el-input v-model="basicQuery.StrresponIdcard" size="small" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="负责人电话:" prop="StrresponTel">
                            <el-input v-model="basicQuery.StrresponTel" size="small" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="负责人邮箱:" prop="Strresponemail">
                            <el-input v-model="basicQuery.Strresponemail" size="small" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="法人姓名:" prop="Strlegalper">
                            <el-input v-model="basicQuery.Strlegalper" size="small" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="股东姓名:" prop="Strshareholder">
                            <el-input v-model="basicQuery.Strshareholder" size="small" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="施工队星级:" prop="StrConstrteamStar">
                            <!-- <span>{{basicQuery.StrConstrteamStar}}</span> -->
                            <el-select v-model="basicQuery.StrConstrteamStar" placeholder="" size="small" >
                                <el-option label="一级" value="一级"></el-option>
                                <el-option label="二级" value="二级"></el-option>
                                <el-option label="三级" value="三级"></el-option>
                                <el-option label="无" value="无"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="联系地址:" prop="StrresponAddr">
                            <el-input v-model="basicQuery.StrresponAddr" size="small" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="仓库地址:" prop="StrwarehouseAddr">
                            <el-input v-model="basicQuery.StrwarehouseAddr" size="small" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="纳入日期:" prop="DtBringDate">
                            <el-date-picker size="small" value-format="yyyy-MM-dd"
                            v-model="basicQuery.DtBringDate"
                            type="date"
                            placeholder="">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="服务状态:" prop="StrSerStatus">
                            <el-select v-model="basicQuery.StrSerStatus" placeholder="" size="small">
                                <el-option label="正常" value="正常"></el-option>
                                <el-option label="退出" value="退出"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="退出日期:" prop="DtexitDate" v-if="basicQuery.StrSerStatus == '退出'">
                            <el-date-picker size="small" value-format="yyyy-MM-dd"
                            v-model="basicQuery.DtexitDate"
                            type="date"
                            placeholder="">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="服务覆盖城市:" prop="StrServicecities">
                            <el-cascader ref="cascaderSignArr" :props="depprops" filterable v-model="resetAddress" size="small" :options="provinces" @change="changeArea"></el-cascader>
                            <!-- <el-select v-model="basicQuery.StrServicecities" placeholder="" size="small" >
                                <el-option v-for="item in serCityList" :key="item.Id" :label="item.Name" :value="item.Name"></el-option>
                            </el-select> -->
                        </el-form-item>
                    </el-form>
                    <div class="f_upload_box">
                        <p class="r_edit_title">营业执照</p>
                        <div class="f_upload_list">
                            <!-- <div class="f_upload_left">营业执照:</div> -->
                            <div class="f_upload_right">
                                <p class="u_txt">注：含机电设备安装等营业范围</p>
                                <div class="f_date_box">
                                    <div class="f_left">营业执照有效期:</div>
                                    <el-date-picker size="small" value-format="yyyy-MM-dd"
                                    v-model="picDate.DtStartDate" @change="picStartChange"
                                    type="date"
                                    placeholder=""></el-date-picker>
                                    <span>至</span>
                                    <el-date-picker size="small" value-format="yyyy-MM-dd"
                                    v-model="picDate.DtEndDate" @change="picEndChange"
                                    type="date"
                                    placeholder="">
                                    </el-date-picker>
                                    <!-- <el-date-picker v-model="lifespanVal" size="small" type="daterange" style="width:330px!important;"
                                        range-separator="至"  value-format="yyyy-MM-dd"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期">
                                    </el-date-picker> -->
                                </div>
                                <!-- <el-upload
                                    class="p_plan_upload"
                                    accept=".doc,.docx,.PDF,.xlsx,.xls,.jpg,.jpeg,.png"
                                    action="#"
                                    :on-change="(file, fileList)=>{return handleUpdateChange(file,fileList,fileSupList01,'1')}"
                                    :on-remove="(file, fileList)=>{return handleUpdateRemove(file,fileList,fileSupList01)}"
                                    :auto-upload="false"
                                    :multiple="true"
                                    :file-list="fileSupList01">
                                    <el-button size="small" type="text" icon="el-icon-plus" class="com_upload_btn"></el-button>
                                </el-upload> -->
                                <!--文件预览及下载-->
                                <!-- <el-link type="primary" v-for="(item,index) in fileSupList01" :key="index+'a'" @click.prevent="downloadFile(item)">
                                    {{ item.name }}
                                </el-link> -->
                                <el-upload action="#" list-type="picture-card" :auto-upload="false" ref="upload1" :file-list="fileSupList01"
                                :on-change="(file, fileList)=>{return handleUpdateChange(file,fileList,fileSupList01,'1')}">
                                    <i slot="default" class="el-icon-plus"></i>
                                    <div slot="file" slot-scope="{file}" class="up_box">
                                        <img v-if="updataIf(file)" class="file_img" src="./../../assets/images/file.png" alt="">
                                        <img v-else class="el-upload-list__item-thumbnail" :src="tablePath+file.url" alt="">
                                        <span class="el-upload-list__item-actions">
                                            <span v-if="updataIf(file)" class="el-upload-list__item-delete" @click="handleDownload(file)">
                                                <i class="el-icon-download"></i>
                                            </span>
                                            <span v-if="!updataIf(file)" class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                                                <i class="el-icon-zoom-in"></i>
                                            </span>
                                            <span v-if="!disabled01" class="el-upload-list__item-delete" @click="handleRemove(file,fileSupList01,'1')">
                                                <i class="el-icon-delete"></i>
                                            </span>
                                        </span>
                                    </div>
                                </el-upload>
                            </div>
                        </div>
                        <p class="r_edit_title">法人委托授权书</p>
                        <div class="f_upload_list">
                            <div class="f_date_box">
                                <div class="f_left f_left02">样张图片:</div>
                                <el-image :preview-src-list="[tablePath+'85ad7fff2f7b4901845a2a3434afc244/20230530090308119.jpg']"
                                style="width: 80px; max-height: 80px"
                                :src="tablePath+'85ad7fff2f7b4901845a2a3434afc244/20230530090308119.jpg'"
                                :fit="'cover'"></el-image>
                            </div>
                            <!-- <div class="f_upload_left">法人委托授权书:</div> -->
                            <div class="f_upload_right">
                                <el-upload action="#" list-type="picture-card" :auto-upload="false" ref="upload2" :file-list="fileSupList02"
                                :on-change="(file, fileList)=>{return handleUpdateChange(file,fileList,fileSupList02,'2')}">
                                    <i slot="default" class="el-icon-plus"></i>
                                    <div slot="file" slot-scope="{file}" class="up_box">
                                         <img v-if="updataIf(file)" class="file_img" src="./../../assets/images/file.png" alt="">
                                        <img v-else class="el-upload-list__item-thumbnail" :src="tablePath+file.url" alt="">
                                        <span class="el-upload-list__item-actions">
                                            <span v-if="updataIf(file)" class="el-upload-list__item-delete" @click="handleDownload(file)">
                                                <i class="el-icon-download"></i>
                                            </span>
                                            <span v-if="!updataIf(file)" class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                                                <i class="el-icon-zoom-in"></i>
                                            </span>
                                            <span v-if="!disabled01" class="el-upload-list__item-delete" @click="handleRemove(file,fileSupList02,'2')">
                                                <i class="el-icon-delete"></i>
                                            </span>
                                        </span>
                                    </div>
                                </el-upload>
                            </div>
                        </div>
                        <p class="r_edit_title">工程车照片</p>
                        <div class="f_upload_list">
                            <!-- <div class="f_upload_left">工程车照片:</div> -->
                            <div class="f_upload_right">
                                <p class="u_txt">注：请上传3张， 前、后、侧面</p>
                                <div class="f_date_box">
                                    <div class="f_left f_left01">车牌号:</div>
                                    <el-input v-model="plateNumber" size="small" clearable></el-input>
                                </div>
                                <el-upload action="#" list-type="picture-card" :auto-upload="false" ref="upload3" :file-list="fileSupList03"
                                :on-change="(file, fileList)=>{return handleUpdateChange(file,fileList,fileSupList03,'3')}">
                                    <i slot="default" class="el-icon-plus"></i>
                                    <div slot="file" slot-scope="{file}" class="up_box">
                                         <img v-if="updataIf(file)" class="file_img" src="./../../assets/images/file.png" alt="">
                                        <img v-else class="el-upload-list__item-thumbnail" :src="tablePath+file.url" alt="">
                                        <span class="el-upload-list__item-actions">
                                            <span v-if="updataIf(file)" class="el-upload-list__item-delete" @click="handleDownload(file)">
                                                <i class="el-icon-download"></i>
                                            </span>
                                            <span v-if="!updataIf(file)" class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                                                <i class="el-icon-zoom-in"></i>
                                            </span>
                                            <span v-if="!disabled01" class="el-upload-list__item-delete" @click="handleRemove(file,fileSupList03,'3')">
                                                <i class="el-icon-delete"></i>
                                            </span>
                                        </span>
                                    </div>
                                </el-upload>
                            </div>
                        </div>
                        <p class="r_edit_title">仓库照片</p>
                        <div class="f_upload_list">
                            <!-- <div class="f_upload_left">仓库照片:</div> -->
                            <div class="f_upload_right">
                                <p class="u_txt">注：需清晰明亮，不小于15平方</p>
                                <el-upload action="#" list-type="picture-card" :auto-upload="false" ref="upload4" :file-list="fileSupList04"
                                :on-change="(file, fileList)=>{return handleUpdateChange(file,fileList,fileSupList04,'4')}">
                                    <i slot="default" class="el-icon-plus"></i>
                                    <div slot="file" slot-scope="{file}" class="up_box">
                                         <img v-if="updataIf(file)" class="file_img" src="./../../assets/images/file.png" alt="">
                                        <img v-else class="el-upload-list__item-thumbnail" :src="tablePath+file.url" alt="">
                                        <span class="el-upload-list__item-actions">
                                            <span v-if="updataIf(file)" class="el-upload-list__item-delete" @click="handleDownload(file)">
                                                <i class="el-icon-download"></i>
                                            </span>
                                            <span v-if="!updataIf(file)" class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                                                <i class="el-icon-zoom-in"></i>
                                            </span>
                                            <span v-if="!disabled01" class="el-upload-list__item-delete" @click="handleRemove(file,fileSupList04,'4')">
                                                <i class="el-icon-delete"></i>
                                            </span>
                                        </span>
                                    </div>
                                </el-upload>
                            </div>
                        </div>
                        <p class="r_edit_title">其他资质</p>
                        <div class="f_upload_list">
                            <!-- <div class="f_upload_left">其他资质:</div> -->
                            <div class="f_upload_right">
                                <p class="u_txt">注：上传机电设备安装许可/安全卫生许可等</p>
                                <el-upload action="#" list-type="picture-card" :auto-upload="false" ref="upload5" :file-list="fileSupList05"
                                :on-change="(file, fileList)=>{return handleUpdateChange(file,fileList,fileSupList05,'5')}">
                                    <i slot="default" class="el-icon-plus"></i>
                                    <div slot="file" slot-scope="{file}" class="up_box">
                                         <img v-if="updataIf(file)" class="file_img" src="./../../assets/images/file.png" alt="">
                                        <img v-else class="el-upload-list__item-thumbnail" :src="tablePath+file.url" alt="">
                                        <span class="el-upload-list__item-actions">
                                            <span v-if="updataIf(file)" class="el-upload-list__item-delete" @click="handleDownload(file)">
                                                <i class="el-icon-download"></i>
                                            </span>
                                            <span v-if="!updataIf(file)" class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                                                <i class="el-icon-zoom-in"></i>
                                            </span>
                                            <span v-if="!disabled01" class="el-upload-list__item-delete" @click="handleRemove(file,fileSupList05,'5')">
                                                <i class="el-icon-delete"></i>
                                            </span>
                                        </span>
                                    </div>
                                </el-upload>
                            </div>
                        </div>
                        <p class="r_edit_title">图片上传渠道</p>
                        <div class="f_upload_list">
                            <!-- <div class="f_upload_left">图片上传渠道:</div> -->
                            <div class="f_upload_right">
                                <p class="u_txt">注：日常盖章图片反馈（处罚/收款信息表等）</p>
                                <el-upload action="#" list-type="picture-card" :auto-upload="false" ref="upload6" :file-list="fileSupList06"
                                :on-change="(file, fileList)=>{return handleUpdateChange(file,fileList,fileSupList06,'6')}">
                                    <i slot="default" class="el-icon-plus"></i>
                                    <div slot="file" slot-scope="{file}" class="up_box">
                                         <img v-if="updataIf(file)" class="file_img" src="./../../assets/images/file.png" alt="">
                                        <img v-else class="el-upload-list__item-thumbnail" :src="tablePath+file.url" alt="">
                                        <span class="el-upload-list__item-actions">
                                            <span v-if="updataIf(file)" class="el-upload-list__item-delete" @click="handleDownload(file)">
                                                <i class="el-icon-download"></i>
                                            </span>
                                            <span v-if="!updataIf(file)" class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                                                <i class="el-icon-zoom-in"></i>
                                            </span>
                                            <span v-if="!disabled01" class="el-upload-list__item-delete" @click="handleRemove(file,fileSupList06,'6')">
                                                <i class="el-icon-delete"></i>
                                            </span>
                                        </span>
                                    </div>
                                </el-upload>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="e_btns_box">
            <div class="e_btns_content">
                <el-button @click="backHandle">取消</el-button>
                <el-button type="primary" :loading="btnLoading" @click="saveHandle">保存</el-button>
            </div>
        </div>
        <!-- 图片预览 -->
        <el-dialog :visible.sync="predialogVisible" :append-to-body="true">
            <img width="100%" :src="tablePath+dialogImageUrl" alt="">
        </el-dialog>
    </div>
</template>
  
<script>
import xz from "./../../common";
import moment from 'moment'
export default {
    data() {
        var validatePhone = (rule, value, callback) => {
            const phoneReg = /^(11[0-9]|12[0-9]|13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])\d{8}$/i;
            // console.log('validatePhone',value)
            if (value.length == 11 && phoneReg.test(value)) {
                //校验通过
                callback()
            } else {
                callback(new Error('请输入正确的手机号'))
            }
        }
        var validatecard = (rule, value, callback) => {
            if (value.length != 18) {
                callback(new Error('身份证号码格式不正确'));
            } else {
                let idcode = value;
                let weight_factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2,];
                let check_code = ["1", "0", "X", "9", "8", "7", "6", "5", "4", "3", "2"];
                let code = idcode + "";
                let last = idcode[17].toUpperCase(); //最后一个
                let seventeen = code.substring(0, 17);
                // ISO 7064:1983.MOD 11-2
                // 判断最后一位校验码是否正确
                let arr = seventeen.split("");
                let len = arr.length;
                let num = 0;
                for (let i = 0; i < len; i++) {
                num = num + arr[i] * weight_factor[i];
                }
                // 获取余数
                var resisue = num % 11;
                var last_no = check_code[resisue];
                // 格式的正则
                // 正则思路
                var idcard_patter = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
                // 判断格式是否正确
                var format = idcard_patter.test(idcode);
                if (last === last_no && format == true) {
                callback()
                } else {
                callback(new Error('身份证号码格式不正确'));
                }
            }
        };
        return {
            pageTitle:'新增施工队',
            tablePath: this.$store.state.EMP.docPath,
            disabled01:false,
            predialogVisible:false,
            dialogImageUrl:'',//预览图片
            btnLoading:false,
            formLoading:false,
            // 默认头像
            defaultPic: require(("./../../assets/images/psn.png")),
            // 规则
            basicRules: {
                StrConstrteamCode: [
                    { required: true, message: '请输入施工队编号', trigger: 'blur' }
                ],
                StrRegisShortCompany: [
                    { required: true, message: '请输入公司简称', trigger: 'blur' }
                ],
                StrresponName: [
                    { required: true, message: '请输入负责人姓名', trigger: 'blur' }
                ],
                StrArea: [
                    { required: true, message: '请选择区域', trigger: 'change' }
                ],
                StrCityCompany: [
                    { required: true, message: '请选择城市公司', trigger: 'change' }
                ],
                StrRegisCompany: [
                    { required: true, message: '请输入公司名称', trigger: 'blur' }
                ],
                StrUsccode: [
                    { required: true, message: '请输入公司统一社会信用代码', trigger: 'blur' }
                ],
                StrresponIdcard: [
                    { required: true, message: '请输入身份证号码', trigger: 'blur' },
                    { message: '请输入正确的身份证号码', validator: validatecard, trigger: ['blur'] }
                ],
                StrresponTel: [
                    { required: true, message: '请输入负责人电话', trigger: 'blur' },
                    { validator: validatePhone, trigger: ['blur'] }
                ],
                DtBringDate: [
                    { required: true, message: '请选择纳入日期', trigger: 'change' }
                ],
                StrSerStatus: [
                    { required: true, message: '请选择服务状态', trigger: 'change' }
                ],
                Strresponemail: [
                    { required: true, message: '请输入负责人邮箱', trigger: 'blur' },
                    { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
                ]
            },
            isDetail: true,
            isEdit:false,
            // 省份
            provinces: [],
            // 区域参数
            areaQuery:{
                currpage: 1,
                perpage:100000,
                strType:'Area', //Area （取区域）  CityCompany （取城市公司）  Province（取省份） City（取城市）
                strName:''//参数 取区域不用传 如strType=CityCompany传区域的名字
            },
            // 城市公司参数
            cityCompanyQuery:{
                currpage: 1,
                perpage:100000,
                strType:'CityCompany',
                strName:''
            },
            // 省市参数(服务覆盖城市)
            serCityQuery:{
                strgrade:'3' //1 区域开始 2城市公司开始 3省 4 市
            },
            // 获取所有市
            allCityQuery:{
                strgrade:'4'
            },
            // 基础信息参数
            basicQuery:{
                GdteamId:'',
                StrConstrteamCode:'', //施工队编号
                StrConstrteamName:'', //施工队名称
                StrArea:'', //区域
                StrCityCompany:'', //城市公司
                StrConstrteamStar:'', //施工队星级
                Strmaterialpackage:'', //协议包含物料套餐
                StrresponName:'', //负责人姓名
                StrresponTel:'', //负责人电话
                Strresponemail:'', //负责人邮箱
                StrresponAddr:'', //联系地址
                StrwarehouseAddr:'', //仓库地址
                StrresponIdcard:'', //负责人身份证号
                StrRegisCompany:'', //公司名称
                StrRegisShortCompany:'', //公司简称
                StrUsccode:'', //公司统一社会信用代码
                Strlegalper:'', //法人姓名
                Strshareholder:'', //股东姓名
                StrServicecities:'', //服务覆盖城市
                StrDockplatformser:'', //对接平台服务商
                StrSerStatus:'', //服务状态
                DtBringDate:'', //纳入日期
                DtexitDate:'',// 退出时间
                StrCity:''// 城市
            },
            // 区域
            areaList: [],
            // 城市公司
            cityCompanyList: [],
            // 服务覆盖城市
            serCityList:[],
            // 营业执照
            fileSupList01:[],
            // 法人委托授权书
            fileSupList02:[],
            fileSupList03:[],
            fileSupList04:[],
            fileSupList05:[],
            fileSupList06:[],
            // 覆盖城市
            resetAddress:[],
            // 营业执照有效期
            lifespanVal:[],
            // 车牌号
            plateNumber:'',
            activeName:'',
            // 营业执照有效期
            picDate:{
                DtStartDate:'',
                DtEndDate:''
            },
            // 服务状态列表参数
            serviceQuery:{
                StrPerStatus:'StrPerStatus'
            },
            serviceList:[],
            checkQuery:{
                StrConstrteamCode:'',
                GdteamId:''
            },
            cityList:[],//城市列表
            depprops: { label: 'strname', value: 'strname', children: 'children', multiple: true }
        }
    },
    created() {
        // console.log('yy',this.$route.params)
        // this.processQuery.Jobid = this.$route.params.Jobid
        if(!this.isNull(this.$route.query.id)){
            this.basicQuery.GdteamId = this.$route.query.id
            this.isEdit = true
            this.pageTitle = '编辑施工队'
            // 获取详情
            this.getDetailData(this.basicQuery.GdteamId)
        }else{
            this.isEdit = false
            this.pageTitle = '新增施工队'
            this.getAreaTree(this.serCityQuery,'province')
        }
        // 获取区域列表
        this.getAreaLists(this.areaQuery,'area')
        this.getAreaTree(this.allCityQuery,'city')
    },
    methods:{
        // 跳转施工队员新增页面
        addOneHandle(){
            this.$router.push({
                path: '/updateTeamMember',
                query: {
                    GdteamId: this.basicQuery.GdteamId
                }
            })
        },
        // 修改营业执照开始日期
        picStartChange(val){
            if(!this.isNull(this.fileSupList01)){
                for (let i = 0; i < this.fileSupList01.length; i++) {
                    let element1 = this.fileSupList01[i];
                    this.$set(element1,'DtStartDate',this.picDate.DtStartDate);
                    this.$set(element1,'DtEndDate',this.picDate.DtEndDate);
                }
            }
        },
        // 修改营业执照结束日期
        picEndChange(val){
            if(!this.isNull(this.fileSupList01)){
                for (let i = 0; i < this.fileSupList01.length; i++) {
                    let element1 = this.fileSupList01[i];
                    this.$set(element1,'DtStartDate',this.picDate.DtStartDate);
                    this.$set(element1,'DtEndDate',this.picDate.DtEndDate);
                }
            }
        },
        // 保存
        saveHandle(){
            let allFileList = [];
            this.$refs['enterResumeForm'].validate((valid) => {
                if (valid) {
                    this.basicQuery.StrConstrteamName = this.basicQuery.StrConstrteamCode + this.basicQuery.StrRegisShortCompany
                    // this.basicQuery.StrServicecities = this.resetAddress.toString()
                    // if(this.isNull(this.lifespanVal)){
                    //     this.$message({ type: 'warning', message: '请选择营业执照有效期' })
                    //     return false
                    // }
                    // if(this.isNull(this.fileSupList01)){
                    //     this.$message({ type: 'warning', message: '请上传营业执照' })
                    //     return false
                    // }
                    // if(this.isNull(this.fileSupList02)){
                    //     this.$message({ type: 'warning', message: '请上传法人委托授权书' })
                    //     return false
                    // }
                    // if(this.isNull(this.plateNumber)){
                    //     this.$message({ type: 'warning', message: '请填写车牌号' })
                    //     return false
                    // }
                    // if(this.isNull(this.fileSupList03)){
                    //     this.$message({ type: 'warning', message: '请上传工程车照片' })
                    //     return false
                    // }
                    // if(!this.isNull(this.fileSupList03)&&this.fileSupList03.length<3){
                    //     this.$message({ type: 'warning', message: '请至少上传3张工程车照片' })
                    //     return false
                    // }
                    // if(this.isNull(this.fileSupList04)){
                    //     this.$message({ type: 'warning', message: '请上传仓库照片' })
                    //     return false
                    // }
                    if(!this.isNull(this.picDate.DtStartDate)){
                        if(!this.isNull(this.picDate.DtEndDate)){
                            if(new Date(this.picDate.DtStartDate).getTime()>new Date(this.picDate.DtEndDate).getTime()){
                                this.$message({ type: 'warning', message: '开始日期不能比结束日期大' })
                                return false
                            }
                        }else{
                            this.$message({ type: 'warning', message: '请选择营业执照有效结束日期' })
                            return false
                        }
                    }else{
                        if(!this.isNull(this.picDate.DtEndDate)){
                            this.$message({ type: 'warning', message: '请选择营业执照有效开始日期' })
                            return false
                        }
                    }
                    this.btnLoading = true
                    if(!this.isNull(this.fileSupList01)){
                        for (let i = 0; i < this.fileSupList01.length; i++) {
                            let element1 = this.fileSupList01[i];
                            this.$set(element1,'DtStartDate',this.picDate.DtStartDate);
                            this.$set(element1,'DtEndDate',this.picDate.DtEndDate);
                        }
                    }
                    if(!this.isNull(this.fileSupList03)&&!this.isNull(this.plateNumber)){
                        for (let j = 0; j < this.fileSupList03.length; j++) {
                            let element3 = this.fileSupList03[j];
                            this.$set(element3,'StrRemark',this.plateNumber);
                        }
                    }
                    allFileList = this.fileSupList01.concat(this.fileSupList02, this.fileSupList03, this.fileSupList04, this.fileSupList05, this.fileSupList06)
                    // 去重
                    allFileList = allFileList.filter(function (item, index, self) {
                        return self.indexOf(el => el.url == item.url) == -1;
                    });
                    // console.log('saveEnterHandle', this.basicQuery,allFileList)
                    xz.saveConstrTeaminfo(this.basicQuery,allFileList).then(res => {
                        // console.log('saveEnterHandle', res)
                        if (res.status == 'ok') {
                            this.$message({ type: 'success', message: '操作成功' })
                            this.$router.push(
                                { path: '/supplierManage'}
                            )
                        }else{
                            this.$message({ type: 'error', message: res.msg })
                        }
                        this.btnLoading = false
                    })
                } else {
                    return false;
                }
            })
        },
        // 判断施工队编号是否存在
        checkPresentHandle(){
            this.checkQuery.StrConstrteamCode = this.basicQuery.StrConstrteamCode
            this.checkQuery.GdteamId = this.basicQuery.GdteamId
            xz.getIsUsedteamCode(this.checkQuery).then(res => {
                // console.log('eee', res)
                if (res.status == 'error') {
                    this.$message({ type: 'warning', message: res.msg })
                    this.basicQuery.StrConstrteamCode = ''
                    return
                }
            })
        },
        // 判断文件类型,图片预览，文件下载
        updataIf(e) {
            if (e.fileName) {
                let type1 = e.fileName.substring(e.fileName.length-4,e.fileName.length)
                if (type1.indexOf('png')>-1||type1.indexOf('PNG')>-1||type1.indexOf('JPG')>-1||type1.indexOf('JPEG')>-1||type1.indexOf('jpg')>-1||type1.indexOf('jpeg')>-1||type1 == 'webp') {
                    return false
                } else {
                    return true
                }
            } else {
                let type2 = e.name.substring(e.name.length-4,e.name.length)
                if (type2.indexOf('png')>-1||type2.indexOf('PNG')>-1||type2.indexOf('JPG')>-1||type2.indexOf('JPEG')>-1||type2.indexOf('jpg')>-1||type2.indexOf('jpeg')>-1||type2 == 'webp') {
                    return false
                } else {
                    return true
                }
            }
        },
        // 获取详情
        getDetailData(id){
            let that = this
            xz.getConstrTeamDetail({GdteamId:id}).then(res => {
                // console.log('www', res)
                if (res.status == 'ok') {
                    that.basicQuery = {
                        GdteamId:res.msg.GdteamId,
                        StrConstrteamCode:res.msg.StrConstrteamCode, //施工队编号
                        StrConstrteamName:res.msg.StrConstrteamName, //施工队名称
                        StrArea:res.msg.StrArea, //区域
                        StrCityCompany:res.msg.StrCityCompany,//城市公司
                        StrPerStatus:res.msg.StrPerStatus, //人员服务状态
                        StrConstrteamStar:res.msg.StrConstrteamStar, //施工队星级
                        Strmaterialpackage:res.msg.Strmaterialpackage, //协议包含物料套餐
                        StrresponName:res.msg.StrresponName, //负责人姓名
                        StrresponTel:res.msg.StrresponTel, //负责人电话
                        Strresponemail:res.msg.Strresponemail, //负责人邮箱
                        StrresponAddr:res.msg.StrresponAddr, //联系地址
                        StrwarehouseAddr:res.msg.StrwarehouseAddr, //仓库地址
                        StrresponIdcard:res.msg.StrresponIdcard, //负责人身份证号
                        StrRegisCompany:res.msg.StrRegisCompany, //公司名称
                        StrRegisShortCompany:res.msg.StrRegisShortCompany, //公司简称
                        StrUsccode:res.msg.StrUsccode, //公司统一社会信用代码
                        Strlegalper:res.msg.Strlegalper, //法人姓名
                        Strshareholder:res.msg.Strshareholder, //股东姓名
                        StrServicecities:res.msg.StrServicecities, //服务覆盖城市
                        StrDockplatformser:res.msg.StrDockplatformser, //对接平台服务商
                        StrSerStatus:res.msg.StrSerStatus, //服务状态
                        DtBringDate:res.msg.DtBringDate, //纳入日期
                        DtexitDate:res.msg.DtexitDate,// 退出时间
                        StrCity:res.msg.StrCity// 城市
                    }
                    that.getAreaTree(that.serCityQuery,'province')
                    if(!that.isNull(res.msg.StrConstrteamName)){
                        let resTxt = res.msg.StrConstrteamName.split(res.msg.StrConstrteamCode)
                        that.basicQuery.StrRegisShortCompany = resTxt[1]
                    }
                    // this.resetAddress = res.msg.StrServicecities.split(',')
                    // this.$nextTick(() => { //inputValue presentText
                    //     that.$refs[`cascaderSignArr`].inputValue = res.msg.StrServicecities
                    //     // console.log('33',that.$refs[`cascaderSignArr`])
                    // })
                    if(!that.isNull(res.msgfile1)){
                        that.picDate.DtStartDate = res.msgfile1[0].DtStartDate
                        that.picDate.DtEndDate = res.msgfile1[0].DtEndDate
                        that.lifespanVal = [res.msgfile1[0].DtStartDate,res.msgfile1[0].DtEndDate]
                    }
                    if(!that.isNull(res.msgfile3)){
                        that.plateNumber = res.msgfile3[0].StrRemark
                    }
                    if(!that.isNull(res.msgfile1)){
                        for (let i = 0; i < res.msgfile1.length; i++) {
                            let element1 = res.msgfile1[i];
                            that.fileSupList01.push({
                                name: element1.StrFile,
                                url: element1.StrFileUrl,
                                GdfileId:element1.GdfileId, //文件id
                                GdteamperId:element1.GdteamperId, //队员id
                                StrFile:element1.StrFile, //文件名称
                                StrFileUrl: element1.StrFileUrl, //文件路径
                                StrFileType:element1.StrFileType, //种类 1营业执照 2法人委托授权书（强制）3工程车照片（强制）4仓库照片（强制）5 其他资质1（不强制）6图片上传渠道（不强制）
                                StrUrlType:element1.StrUrlType, //图片或者文档
                                StrFileContent:element1.StrFileContent, //文件内容
                                StrRemark:element1.StrRemark, //备注
                                DtStartDate:element1.DtStartDate, //开始时间
                                DtEndDate:element1.DtEndDate //结束
                            })
                        }
                    }
                    if(!that.isNull(res.msgfile2)){
                        for (let j = 0; j < res.msgfile2.length; j++) {
                            let element2 = res.msgfile2[j];
                            that.fileSupList02.push({
                                name: element2.StrFile,
                                url: element2.StrFileUrl,
                                GdfileId:element2.GdfileId, //文件id
                                GdteamperId:element2.GdteamperId, //队员id
                                StrFile:element2.StrFile, //文件名称
                                StrFileUrl: element2.StrFileUrl, //文件路径
                                StrFileType:element2.StrFileType, //种类 1营业执照 2法人委托授权书（强制）3工程车照片（强制）4仓库照片（强制）5 其他资质1（不强制）6图片上传渠道（不强制）
                                StrUrlType:element2.StrUrlType, //图片或者文档
                                StrFileContent:element2.StrFileContent, //文件内容
                                StrRemark:element2.StrRemark, //备注
                                DtStartDate:element2.DtStartDate, //开始时间
                                DtEndDate:element2.DtEndDate //结束
                            })
                        }
                    }
                    if(!that.isNull(res.msgfile3)){
                        for (let k = 0; k < res.msgfile3.length; k++) {
                            let element3 = res.msgfile3[k];
                            that.fileSupList03.push({
                                name: element3.StrFile,
                                url: element3.StrFileUrl,
                                GdfileId:element3.GdfileId, //文件id
                                GdteamperId:element3.GdteamperId, //队员id
                                StrFile:element3.StrFile, //文件名称
                                StrFileUrl: element3.StrFileUrl, //文件路径
                                StrFileType:element3.StrFileType, //种类 1营业执照 2法人委托授权书（强制）3工程车照片（强制）4仓库照片（强制）5 其他资质1（不强制）6图片上传渠道（不强制）
                                StrUrlType:element3.StrUrlType, //图片或者文档
                                StrFileContent:element3.StrFileContent, //文件内容
                                StrRemark:element3.StrRemark, //备注
                                DtStartDate:element3.DtStartDate, //开始时间
                                DtEndDate:element3.DtEndDate //结束
                            })
                        }
                    }
                    if(!that.isNull(res.msgfile4)){
                        for (let l = 0; l < res.msgfile4.length; l++) {
                            let element4 = res.msgfile4[l];
                            that.fileSupList04.push({
                                name: element4.StrFile,
                                url: element4.StrFileUrl,
                                GdfileId:element4.GdfileId, //文件id
                                GdteamperId:element4.GdteamperId, //队员id
                                StrFile:element4.StrFile, //文件名称
                                StrFileUrl: element4.StrFileUrl, //文件路径
                                StrFileType:element4.StrFileType, //种类 1营业执照 2法人委托授权书（强制）3工程车照片（强制）4仓库照片（强制）5 其他资质1（不强制）6图片上传渠道（不强制）
                                StrUrlType:element4.StrUrlType, //图片或者文档
                                StrFileContent:element4.StrFileContent, //文件内容
                                StrRemark:element4.StrRemark, //备注
                                DtStartDate:element4.DtStartDate, //开始时间
                                DtEndDate:element4.DtEndDate //结束
                            })
                        }
                    }
                    if(!that.isNull(res.msgfile5)){
                        for (let m = 0; m < res.msgfile5.length; m++) {
                            let element5 = res.msgfile5[m];
                            that.fileSupList05.push({
                                name: element5.StrFile,
                                url: element5.StrFileUrl,
                                GdfileId:element5.GdfileId, //文件id
                                GdteamperId:element5.GdteamperId, //队员id
                                StrFile:element5.StrFile, //文件名称
                                StrFileUrl: element5.StrFileUrl, //文件路径
                                StrFileType:element5.StrFileType, //种类 1营业执照 2法人委托授权书（强制）3工程车照片（强制）4仓库照片（强制）5 其他资质1（不强制）6图片上传渠道（不强制）
                                StrUrlType:element5.StrUrlType, //图片或者文档
                                StrFileContent:element5.StrFileContent, //文件内容
                                StrRemark:element5.StrRemark, //备注
                                DtStartDate:element5.DtStartDate, //开始时间
                                DtEndDate:element5.DtEndDate //结束
                            })
                        }
                    }
                    if(!that.isNull(res.msgfile6)){
                        for (let n = 0; n < res.msgfile6.length; n++) {
                            let element6 = res.msgfile6[n];
                            that.fileSupList06.push({
                                name: element6.StrFile,
                                url: element6.StrFileUrl,
                                GdfileId:element6.GdfileId, //文件id
                                GdteamperId:element6.GdteamperId, //队员id
                                StrFile:element6.StrFile, //文件名称
                                StrFileUrl: element6.StrFileUrl, //文件路径
                                StrFileType:element6.StrFileType, //种类 1营业执照 2法人委托授权书（强制）3工程车照片（强制）4仓库照片（强制）5 其他资质1（不强制）6图片上传渠道（不强制）
                                StrUrlType:element6.StrUrlType, //图片或者文档
                                StrFileContent:element6.StrFileContent, //文件内容
                                StrRemark:element6.StrRemark, //备注
                                DtStartDate:element6.DtStartDate, //开始时间
                                DtEndDate:element6.DtEndDate //结束
                            })
                        }
                    }
                    // 城市公司
                    that.cityCompanyQuery.strName = this.basicQuery.StrArea
                    that.getAreaLists(this.cityCompanyQuery,'cityCompany')
                    // this.fileSupList01 = res.msgfile1
                    // this.fileSupList02 = res.msgfile2
                    // this.fileSupList03 = res.msgfile3
                    // this.fileSupList04 = res.msgfile4
                    // this.fileSupList05 = res.msgfile5
                    // this.fileSupList06 = res.msgfile6
                }else{
                    this.$message({ type: 'error', message: res.msg })
                }
            })
        },
        // 选择区域
        areaChangeHandle(val){
            this.basicQuery.StrCityCompany = ''
            // this.basicQuery.StrServicecities = ''
            this.resetAddress = []
            // 城市公司
            this.cityCompanyQuery.strName = val
            this.getAreaLists(this.cityCompanyQuery,'cityCompany')
        },
        // 选择城市公司
        cityCompanyHandle(val){
            // this.basicQuery.StrServicecities = ''
            // this.resetAddress = []
        },
        changeArea(val){
            // let city = this.$refs.workAddress.getCheckedNodes(true)[0];
            let resCity = []
            console.log('ss',val)
            if (!this.isNull(val)) {
                for (let i = 0; i < val.length; i++) {
                let element = val[i];
                resCity.push(element[1])
                }
                this.basicQuery.StrServicecities = resCity.toString()
            } else {
                this.basicQuery.StrServicecities = ''
            }
            this.resetAddress = val
            // this.basicQuery.StrServicecities = city.value
        },
        // 上传附件
        handleUpdateChange(file, fileList, dataArr, type){
            let formData = new FormData()
            formData.append("action", 'save')
            formData.append("pagename", 'bdocinf')
            formData.append("userid", Cookies.get("userid-b"))
            formData.append("entid", Cookies.get("userid-b"))
            formData.append("entPicFile", file.raw, file.name)
            console.log('entPicFile', file, fileList)
            xz.uploadCert(formData).then(res => {
                // console.log('entPicFile', res)
                if (res) {
                    dataArr.push({
                        name: file.name,
                        url: res,
                        GdfileId:'', //文件id
                        GdteamperId:'', //队员id
                        StrFile:file.name, //文件名称
                        StrFileUrl: res, //文件路径
                        StrFileType:type, //种类 1营业执照 2法人委托授权书（强制）3工程车照片（强制）4仓库照片（强制）5 其他资质1（不强制）6图片上传渠道（不强制）
                        StrUrlType:file.raw.type, //图片或者文档
                        StrFileContent:'', //文件内容
                        StrRemark:'', //备注
                        DtStartDate:'', //开始时间
                        DtEndDate:'' //结束
                    })
                } else {
                    this.$message('文件上传失败,请稍后再试')
                }
            })
        },
        // 放大预览
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url
            this.predialogVisible = true
        },
        // 删除附件
        handleRemove(file,dataArr,type) {
            // console.log('handleRemove01',file);
            if(type == '1'){
                let arr1 = this.$refs.upload1.uploadFiles
                let index1 = arr1.indexOf(file)
                arr1.splice(index1, 1)
            }
            if(type == '2'){
                let arr2 = this.$refs.upload1.uploadFiles
                let index2 = arr2.indexOf(file)
                arr2.splice(index2, 1)
            }
            if(type == '3'){
                let arr3 = this.$refs.upload3.uploadFiles
                let index3 = arr3.indexOf(file)
                arr3.splice(index3, 1)
            }
            if(type == '4'){
                let arr4 = this.$refs.upload4.uploadFiles
                let index4 = arr4.indexOf(file)
                arr4.splice(index4, 1)
            }
            if(type == '5'){
                let arr5 = this.$refs.upload5.uploadFiles
                let index5 = arr5.indexOf(file)
                arr5.splice(index5, 1)
            }
            if(type == '6'){
                let arr6 = this.$refs.upload6.uploadFiles
                let index6 = arr6.indexOf(file)
                arr6.splice(index6, 1)
            }
            let index = dataArr.findIndex(item => {
                if (item.url == file.url) {
                return true
                }
            })
            dataArr.splice(index, 1)
        },
        // 下载附件
        handleDownload(file) {
            console.log(file);
        },
        // 获取区域列表
        getAreaLists(data,type){
            xz.getAreaLists(data).then(res => {
                // console.log('entPicFile', res)
                if (res.status == 'ok') {
                    if(type == 'area'){
                        this.areaList = res.msg
                    }
                    if(type == 'cityCompany'){
                        this.cityCompanyList = res.msg
                    }
                } else {
                    if(type == 'area'){
                        this.areaList = []
                    }
                    if(type == 'cityCompany'){
                        this.cityCompanyList = []
                    }
                }
            })
        },
        // 获取省市列表
        getAreaTree(data,type){
            let that = this
            xz.getAreaTree(data).then(res => {
                // console.log('entPicFile', res)
                if (res.status == 'ok') {
                    if(type == 'province'){
                        this.provinces = res.msg.parent
                        // 服务覆盖城市回显
                        if(!that.isNull(that.basicQuery.StrServicecities)){
                            let sitysArr = that.basicQuery.StrServicecities.split(',')
                            // console.log('222111', sitysArr)
                            that.resetAddress = []
                            let allAddress = []
                            if(sitysArr.length>1){
                                for (let i = 0; i < sitysArr.length; i++) {
                                let element = sitysArr[i];
                                let elePos = that.getPath(this.provinces,element)
                                // console.log('elePos',elePos)
                                    if(elePos.length > 1){
                                        allAddress.push([elePos[0].strname,elePos[1].strname]);
                                    }else{
                                        allAddress.push([elePos[0].strname]);
                                    }
                                }
                                // let posArrValAll = [posArrVal01,posArrVal02]
                                this.resetAddress = allAddress
                                // console.log('222',this.resetAddress)
                            }else if(sitysArr.length==1){
                                let posArrVal = that.getPath(this.provinces,this.basicQuery.StrServicecities);
                                let eleArr = []
                                // console.log('222', posArrVal)
                                if(posArrVal.length>1){
                                for (let i = 0; i < posArrVal.length; i++) {
                                    let element1 = posArrVal[i];
                                    eleArr.push(element1.strname)
                                }
                                that.resetAddress.push(eleArr)
                                }else if(posArrVal.length==1){
                                    that.resetAddress = [posArrVal[0].strname,posArrVal[1].strname]
                                }
                            }
                        }
                    }
                    if(type == 'city'){
                        this.cityList = res.msg.parent
                    }
                } else {
                    if(type == 'province'){
                        this.provinces = []
                    }
                    if(type == 'city'){
                        this.cityList = []
                    }
                }
            })
        },
        // 根据级联选择器最后一级选中的值回显整个选中的数组-岗位
        getPath(treeData, targetName) {
            //  console.log(221, treeData, targetName);
            let path = [];
            let toggle = false;
            for (let i = 0; i < treeData.length; i++) {
                let item = treeData[i];
                path.push({
                    strname:item.strname,
                    strType:item.strType
                });
                if (item.strname == targetName) {
                toggle = true;
                break;
                } else {
                if (item.children) {
                    toggle = this.findPath(item.children, targetName, path, toggle);
                    if (!toggle) {
                    path.pop();
                    } else {
                    break;
                    }
                } else {
                    path.pop();
                }
                }
            }
            if (toggle) {
                // console.log(245, path);
                return path;
            } else {
                return [];
            }
        },
        findPath(nodes, targetName, path, toggle) {
            for (let i = 0; i < nodes.length; i++) {
                let item = nodes[i];
                path.push({
                    strname:item.strname,
                    strType:item.strType
                });
                if (item.strname === targetName) {
                    return true;
                } else {
                    if (item.children) {
                        toggle = this.findPath(item.children, targetName, path, toggle);
                        if (toggle) {
                        return toggle;
                        } else {
                        path.pop();
                        }
                    } else {
                        path.pop();
                    }
                }
            }
            return toggle;
        },
        // 返回
        backHandle(){
            this.$router.back()
            // this.$router.go(-1) // 后退+刷新
        },
        //获取省份
        getprovinces(parent) {
            xz.getArea(parent).then(res => {
                // console.log('getprovinces', res)
                if (res.status == 'ok') {
                this.provinces = res.data.ret;
                } else {
                this.provinces = [];
                }
            })
        },
        //判断是否为空(包含0)
        isNull(o) {
            return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN' || o == ('1900-01-01') || o == '1900-01-01T00:00:00';
        },
        //根据targetName查询该节点和所有父级节点 回显el-cascader组件的值
        getParentsById(list,targetName){
            for (let i in list) {
                if (list[i].strorganname === targetName) {
                    //查询到就返回该数组对象
                    return [list[i]]
                }
                if (list[i].children) {
                    let node = this.getParentsById(list[i].children, targetName)
                    if (node !== undefined) {
                        //查询到把父节点连起来
                    return node.concat(list[i])
                    }
                }
            } 
        }
    }
}
</script>

<style>
.e_handle_content.page_update_supply .e_handle_box .el-input.c_edit_input{
    flex: 1;
    width: 220px;
}
.page_update_supply .e_handle_box .el-input.c_edit_input .el-input__inner{
    width: 220px;
}
.page_update_supply .e_form_box .el-form-item__label:before{
    margin-right: 0;
}
.page_update_supply .e_form_box .el-form-item__label{
    padding: 0 6px 0 0;
}
.page_update_supply .file_img{
    width: 50px;
    height: auto;
}
.page_update_supply .el-upload-list--picture-card .el-upload-list__item-thumbnail{
    width: 100%;
    height: auto;
}
.e_handle_content .el-form--inline .el-form-item__content{
    vertical-align: middle;
}
.e_handle_content .el-form-item__content{
    width: 305px;
}
.e_handle_content .e_half_line01 .el-form-item__content{
    width: 535px;
}
.e_handle_content .f_all_width01 .el-form-item__content{
    width: calc(100% - 135px);
}
.f_all_width .el-form-item__content{
    width: calc(100% - 135px);
}
.e_handle_content .el-form-item{
    margin-bottom: 16px;
    margin-right: 0;
}
.com_upload_btn .el-icon-plus:before{
    font-size: 28px;
    color: #8c939d;
}
/* .page_update_supply .el-upload-list__item .el-icon-close{
    display: block;
} */
</style>
<style scoped>
.f_form_btn .r_title_btns{
    display: flex;
    flex-wrap: wrap;
    flex:1;
    justify-content: flex-end;
}
.f_form_btn{
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    flex-wrap: wrap;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    border-bottom: 1px dashed #ddd;
    margin-bottom: 10px;
    padding: 0 10px 0 20px;
}
.c_edit_txt{
    display: inline-block;
    width: 80px;
    white-space:nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.up_box{
    display: flex;
    width: 148px;
    height: 148px;
    justify-content: center;
    align-items: center;
}
.c_form_box{
    display: flex;
    box-sizing: border-box;
}
.page_update_supply{
    position: relative;
}
.page_update_supply .main-con{
    padding: 0px 15px 80px;
}
.f_date_box{
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}
.f_date_box .f_left{
    text-align: right;
    width: 110px;
    font-size: 14px;
    margin-right: 4px;
    color: #606266;
}
.f_date_box .f_left.f_left01{
    width: 55px;
}
.f_date_box .f_left.f_left02{
    width: 70px;
}
.f_date_box .f_left .note_icon{
    color:#F56C6C;
}
.com_upload_btn{
    background-color: #fbfdff;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 148px;
    height: 148px;
    cursor: pointer;
    line-height: 146px;
    vertical-align: top;
}
.r_edit_title .note_icon{
    color:#F56C6C;
    margin-left: 4px;
}
.f_upload_box{
    width: 100%;
}
.r_edit_title{
    width: 100%;
    font-size: 16px;
    line-height: 30px;
    margin-bottom: 10px;
    font-weight: bold;
    padding-left: 20px;
    border-bottom: 1px dashed #ddd;
    box-sizing: border-box;
    color: #333;
}
.r_edit_title01{
    width: 100px;
    font-size: 16px;
    line-height: 30px;
    font-weight: bold;
    color: #333;
}
.u_txt{
    color:#999;
    font-weight: bold;
    font-size: 13px;
    margin-bottom: 10px;
}
.f_upload_list{
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    margin-bottom: 16px;
    padding-left: 20px;
}
.f_upload_left{
    width: 130px;
    text-align: right;
    vertical-align: middle;
    font-size: 14px;
    color: #606266;
    /* line-height: 40px; */
    padding: 0 12px 0 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
.face_line_box{
  display:flex;
  flex-wrap: wrap;
  font-size: 14px;
  margin-left: 10px;
}
.face_line_box .txts01{
  margin-right: 3px;
}
.face_line_box .txts02{
  margin-left: 3px;
}
.r_flex{
    display: flex;
    align-items: center;
}
.e_bottom_box{
    width: 100%;
    box-sizing: border-box;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: flex-end;
}
.e_bottom_box p{
    margin-right: 10px;
}
.e_handle_form{
    width: 100%;
    margin: 0 auto;
    flex-wrap: wrap;
}
.e_half_line{
    width: 549px;
}
.e_half_line01{
    width: 652px;
}
.page_update_supply .f_date_box .el-date-editor.el-input{
    width: 150px;
}
.e_handle_content .el-input,.e_handle_content .el-cascader,.e_handle_content .el-select{
    width: 300px;
}
.e_form_box{
    margin-top: 10px;
}
.e_btns_content{
    width: 200px;
    margin-left: calc(50% - 160px);
}
.e_btns_box{
    width: 100%;
    display: flex;
    /* justify-content: center; */
    position: fixed;
    bottom: 0;
    background: #fff;
    z-index: 100;
    box-sizing: border-box;
    padding: 10px 0;
}
.f_all_width{
  width: 100%;
  align-items: center;
}
.e_line01{
    display: flex;
    align-items: center;
}
.e_handle_box .txt01{
    font-size: 13px;
    color:#19bd92;
    cursor: pointer;
    margin-left: 5px;
}
.e_handle_form{
    display: flex;
    /* text-align: center; */
}
.e_handle_box{
    width: 100%;
    padding: 10px 0;
    background-color: #fff;
    box-sizing: border-box;
}
.e_handle_box .el-form-item__label{
    padding: 0 5px 0 0;
}
.e_title{
    width: 100%;
    text-align: center;
    line-height: 25px;
    font-size: 16px;
    color: #333333;
}
</style>